import events from 'events'

class EE extends events {
  customNames = {
    SCROLLTOP: 'scroll-top'
  }
}

export default EE
